import * as React from 'react';
import { createGlobalStyle } from 'styled-components';

import DashboardTemplate from './dashboard/components/DashboardTemplate';
import DateLocation from './dashboard/components/DateLocation';
import IndexIndicator from './dashboard/components/IndexIndicator';
import PageHeader from './dashboard/components/PageHeader';
import DateClockContainer from './dashboard/containers/DateClock.container';
// import OutdoorAirDataContainer from './dashboard/containers/OutdoorAirData.container';
import SnapshotGridContainer from './dashboard/containers/SnapshotGrid.container';

import { LocaleProvider } from './dashboard/contexts/locale.context';
import { Condition } from './dashboard/enums/condition.enum';
import { fontWeights } from './ui/inline-styles/variables';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Roboto:100,200,300,400,500');

  html, body {
    margin: 0;
    font-family: 'Roboto', Arial, sans-serif;
    font-weight: ${fontWeights.ultraLight};
    font-size: 16px;
    height: 100%;
    min-height: 100%;
    box-sizing: border-box;
    background-color: #000000;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: ${fontWeights.regular};
  }

  a {
    text-decoration: none;
  }

  p {
    margin: 0;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
    user-select: none;
  }

  #root {
    height: 100%;
  }
`;

class App extends React.Component {
  render() {
    const pageFooter: React.ReactNode = Object.keys(Condition)
      .filter((key: string) => Condition[key] !== Condition.Disconnected)
      .map((key: string) => <IndexIndicator key={key} condition={Condition[key]} />);

    return (
      <>
        <GlobalStyle />

        <LocaleProvider>
          <DashboardTemplate
            pageHeader={<PageHeader />}
            pageFooter={pageFooter}
            dateLocation={<DateLocation dateClock={<DateClockContainer />} />}
            // outdoorAirData={<OutdoorAirDataContainer />}
            outdoorAirData={null}
            snapshot={<SnapshotGridContainer />}
          />
        </LocaleProvider>
      </>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.tsx